import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CustomerMasterService } from '../../services/customer-master-service';
import { DateAdapter } from '@angular/material/core';
import { ServiceMasterService } from '../../services/service-master-service';
import { UtilityService } from 'src/app/modules/accounts-module/accounts/services/utility-service';
import { CustomerModel } from '../../models/customer-model';
import { ServiceMasterModel } from '../../models/service-master-model';
import { TransactionMasterService } from '../../services/transaction-master-service';
import { UnitModel } from '../../models/unit.model';
import { MatDialog } from '@angular/material/dialog';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { CustomSmsPopupComponent } from '../custom-sms-popup/custom-sms-popup.component';
import { TransactionCreatePayload } from '../../models/transaction-create-model';
import { Time, Location } from '@angular/common';
import { TransactionType } from '../../models/transaction.enum';

@Component({
  selector: 'app-transaction-master',
  templateUrl: './transaction-master.component.html',
  styleUrls: ['./transaction-master.component.css'],
})
export class TransactionMasterComponent implements OnInit {
  displayedColumns: string[] = [
    'srNo',
    'service',
    'workDescription',
    'unit',
    'workUnits',
    'startDate',
    'expiryDate',
    'amount',
    'actions',
  ];

  /** Dropdowns */
  public customerList: CustomerModel[] = [];
  public serviceList: ServiceMasterModel[] = [];
  public unitList: UnitModel[] = [];

  public currentServiceLine: any = {
    serviceHeaderId: null,
    unitId: null,
    workUnits: null,
    serviceStartDate: null,
    serviceExpiryInMonths: 0,
    serviceExpiryDate: null,
    quantity: null,
    rate: null,
    discountPercent: 0,
    discountAmount: 0,
    amount: 0,
    scheduleCustomSms: false,
    scheduleCustomSmsList: [],
    serviceWorkDescription: '',
  };

  public selectedCustomerId: number | null = null;
  public addedServiceLines: any[] = [];
  public editIndex: number = -1;
  public transactionNo: string = '';
  public transactionId: number | null = null;

  public TransactionType = TransactionType;
  public transactionType: string | null = null;
  public transactionDate: Date = new Date();
  public todayDate: Date = new Date();
  public isGstTransaction: boolean = false;
  public igstPercent: number = 0;
  public cgstPercent: number = 0;
  public sgstPercent: number = 0;
  public subTotal: number = 0;
  public totalDiscount: number = 0;
  public taxableAmount: number = 0;
  public gstAmount: number = 0;
  public grandTotal: number = 0;
  public isViewMode: boolean = false;
  public isEditMode: boolean = false;

  public get isFormDisabled(): boolean {
    return this.isViewMode;
  }

  public get isServiceLineDisabled(): boolean {
    return this.isViewMode || !this.transactionType || !this.selectedCustomerId;
  }

  constructor(
    private l_CustomerMasterService: CustomerMasterService,
    private l_ServiceMasterService: ServiceMasterService,
    private l_UtilityService: UtilityService,
    private l_TransactionMasterService: TransactionMasterService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private dateAdapter: DateAdapter<Date>,
    private location: Location
  ) { }

  async ngOnInit(): Promise<void> {
    await this.lFN_LoadCustomers();
    await this.lFN_LoadServices();
    await this.lFN_LoadUnits();

    const state = this.location.getState() as any;

    if (state && state.mode) {
      if (state.mode === 'view') {
        this.isViewMode = true;
      } else if (state.mode === 'edit') {
        this.isEditMode = true;
      }

      // Check if data ID exists in the state passed by utility service
      if (state.data && state.data.id) {
        this.lFN_GetTransactionById(state.data.id);
      }
    } else {
      // Fallback: Check Query Params if someone navigated via a direct link / refresh
      this.route.queryParams.subscribe((params) => {
        if (params['mode'] === 'view') {
          this.isViewMode = true;
        } else if (params['mode'] === 'edit') {
          this.isEditMode = true;
        }
        const id = params['id'];
        if (id) {
          this.lFN_GetTransactionById(id);
        }
      });
    }
  }

  async lFN_LoadCustomers(): Promise<void> {
    return new Promise((resolve) => {
      this.l_UtilityService.lFN_ShowLoader();
      this.l_CustomerMasterService.lFN_GetCustomerList().subscribe({
        next: (res: any) => {
          const parsed = JSON.parse(res.body);
          this.customerList = (parsed?.data || []).filter(
            (c: any) => c.isActive === 'YES' || c.customerIsActive === 'YES'
          );
        },
        error: () => {
          this.l_UtilityService.lFN_ErrorToaster(
            'Failed to load customer list',
            'Error'
          );
          this.l_UtilityService.lFN_HideLoader();
          resolve();
        },
        complete: () => {
          this.l_UtilityService.lFN_HideLoader();
          resolve();
        },
      });
    });
  }

  async lFN_LoadServices(): Promise<void> {
    return new Promise((resolve) => {
      this.l_UtilityService.lFN_ShowLoader();
      this.l_ServiceMasterService.lFN_GetServiceList().subscribe({
        next: (res: any) => {
          const parsed = JSON.parse(res.body);
          console.log(parsed?.data);
          this.serviceList = (parsed?.data || []).filter(
            (s: any) => s.serviceIsactive === 'YES'
          );
          console.log(this.serviceList);
        },
        error: () => {
          this.l_UtilityService.lFN_ErrorToaster(
            'Failed to load services',
            'Error'
          );
          this.l_UtilityService.lFN_HideLoader();
          resolve();
        },
        complete: () => {
          this.l_UtilityService.lFN_HideLoader();
          resolve();
        },
      });
    });
  }

  async lFN_LoadUnits(): Promise<void> {
    return new Promise((resolve) => {
      this.l_UtilityService.lFN_ShowLoader();
      this.l_TransactionMasterService.lFN_GetUnitList().subscribe({
        next: (res: any) => {
          const parsed = JSON.parse(res.body);
          this.unitList = (parsed?.data || []).filter(
            (u: any) => u.unitIsActive === 'YES' || u.isActive === 'YES'
          );
        },
        error: () => {
          this.l_UtilityService.lFN_ErrorToaster(
            'Failed to load unit list',
            'Error'
          );
          this.l_UtilityService.lFN_HideLoader();
          resolve();
        },
        complete: () => {
          this.l_UtilityService.lFN_HideLoader();
          resolve();
        },
      });
    });
  }

  lFN_CalculateExpiry(): void {
    if (
      this.currentServiceLine.serviceStartDate &&
      this.currentServiceLine.serviceExpiryInMonths > 0
    ) {
      const startDate = new Date(this.currentServiceLine.serviceStartDate);
      this.currentServiceLine.serviceExpiryDate =
        this.dateAdapter.addCalendarMonths(
          startDate,
          this.currentServiceLine.serviceExpiryInMonths
        );
    } else {
      this.currentServiceLine.serviceExpiryDate = null;
    }
  }

  lFN_CalculateAmount(quantity: number, rate: number, discount: number = 0) {
    let amount = 0;
    if (quantity && rate) {
      amount = quantity * rate - discount;
    }
    return amount > 0 ? amount : 0;
  }

  onCustomSmsChange(event: MatCheckboxChange) {
    if (event.checked) {
      this.openCustomSmsPopup();
    } else {
      this.currentServiceLine.scheduleCustomSmsList = [];
      this.currentServiceLine.scheduleCustomSms = false;
    }
  }

  openCustomSmsPopup() {
    const dialogRef = this.dialog.open(CustomSmsPopupComponent, {
      width: '400px',
      disableClose: true,
      data: {
        dates: this.currentServiceLine.scheduleCustomSmsList
          ? [...this.currentServiceLine.scheduleCustomSmsList]
          : [],
        isViewMode: this.isViewMode,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      // Prevent any edits from updating the data if we are in view mode
      if (this.isViewMode) {
        return;
      }

      if (result) {
        this.currentServiceLine.scheduleCustomSmsList = result;
        this.currentServiceLine.scheduleCustomSms = true;
      } else {
        // Revert to unchecked only if the list has absolutely no dates inside it (they cancelled their first time opening it)
        if (
          !this.currentServiceLine.scheduleCustomSmsList ||
          this.currentServiceLine.scheduleCustomSmsList.length === 0
        ) {
          this.currentServiceLine.scheduleCustomSms = false;
        }
      }
    });
  }

  lFN_AddServiceLine(): void {
    if (!this.transactionType || !this.selectedCustomerId) {
      this.l_UtilityService.lFN_ErrorToaster(
        'Please select Transaction Type and Customer before adding a service.',
        'Validation Error'
      );
      return;
    }

    const qty = Number(this.currentServiceLine.quantity) || 0;
    const rate = Number(this.currentServiceLine.rate) || 0;
    const discountAmount = Number(this.currentServiceLine.discountAmount) || 0;

    if (discountAmount > qty * rate) {
      this.l_UtilityService.lFN_ErrorToaster(
        'Discount cannot be greater than the amount.',
        'Validation Error'
      );
      return;
    }

    // if (
    //   !this.currentServiceLine.serviceHeaderId ||
    //   !this.currentServiceLine.unitId ||
    //   this.currentServiceLine.quantity == null || this.currentServiceLine.quantity === '' || this.currentServiceLine.quantity <= 0 ||
    //   this.currentServiceLine.rate == null || this.currentServiceLine.rate === '' || this.currentServiceLine.rate < 0 ||
    //   !this.currentServiceLine.serviceStartDate ||
    //   this.currentServiceLine.serviceExpiryInMonths == null || this.currentServiceLine.serviceExpiryInMonths === '' || this.currentServiceLine.serviceExpiryInMonths <= 0 ||
    //   !this.currentServiceLine.serviceWorkDescription || this.currentServiceLine.serviceWorkDescription.trim() === ''
    // ) {
    //   this.l_UtilityService.lFN_ErrorToaster('Please fill all mandatory service details.', 'Validation Error');
    //   return;
    // }

    const today = new Date();
    const startDate = new Date(this.currentServiceLine.serviceStartDate);
    const expiryDate = new Date(this.currentServiceLine.serviceExpiryDate);

    if (expiryDate < startDate) {
      this.l_UtilityService.lFN_ErrorToaster(
        'Service expiry date cannot be less than service start date.',
        'Validation Error'
      );
      return;
    }

    if (expiryDate < today) {
      this.l_UtilityService.lFN_ErrorToaster(
        'Service expiry date cannot be less than todays date.',
        'Validation Error'
      );
      return;
    }

    if (
      this.isServiceAdded(
        Number(this.currentServiceLine.serviceHeaderId),
        this.currentServiceLine.serviceWorkDescription
      )
    ) {
      this.l_UtilityService.lFN_ErrorToaster(
        'This service with the same work description is already added.',
        'Validation Error'
      );
      return;
    }

    const service = this.serviceList.find(
      (s) => s.serviceHeaderId == this.currentServiceLine.serviceHeaderId
    );
    const unit = this.unitList.find(
      (u) => u.unitId == this.currentServiceLine.unitId
    );

    const newLine = {
      ...this.currentServiceLine,
      serviceHeaderId: Number(this.currentServiceLine.serviceHeaderId),
      unitId: Number(this.currentServiceLine.unitId),
      serviceName: service ? service.serviceName : '',
      unit: unit ? unit.unitName : '',
      workUnits: this.currentServiceLine.workUnits
        ? String(this.currentServiceLine.workUnits)
        : null,
    };

    if (this.editIndex !== -1) {
      this.addedServiceLines[this.editIndex] = newLine;
      this.editIndex = -1;
      this.addedServiceLines = [...this.addedServiceLines];
    } else {
      this.addedServiceLines = [...this.addedServiceLines, newLine];
    }

    this.lFN_ClearServiceLine();
    this.calculateTotals();
  }

  editServiceLine(index: number): void {
    this.editIndex = index;
    const lineToEdit = this.addedServiceLines[index];
    this.currentServiceLine = { ...lineToEdit };
  }

  removeServiceLine(index: number): void {
    this.addedServiceLines.splice(index, 1);
    this.addedServiceLines = [...this.addedServiceLines];
    this.calculateTotals();
  }

  isServiceAdded(serviceId: number, workDescription?: string): boolean {
    const desc =
      workDescription !== undefined
        ? workDescription
        : this.currentServiceLine.serviceWorkDescription || '';
    return this.addedServiceLines.some(
      (line, index) =>
        index !== this.editIndex &&
        line.serviceHeaderId === serviceId &&
        (line.serviceWorkDescription || '').trim() === desc.trim()
    );
  }

  lFN_ClearServiceLine(): void {
    this.editIndex = -1;
    this.currentServiceLine = {
      serviceHeaderId: null,
      unitId: null,
      workUnits: null,
      serviceStartDate: null,
      serviceExpiryInMonths: 0,
      serviceExpiryDate: null,
      quantity: null,
      rate: null,
      discountPercent: 0,
      discountAmount: 0,
      amount: 0,
      scheduleCustomSms: false,
      scheduleCustomSmsList: [],
      serviceWorkDescription: '',
    };
  }

  calculateTotals(): void {
    // Subtotal before discount
    this.subTotal = this.addedServiceLines.reduce((acc, line) => {
      const quantity = Number(line.quantity) || 0;
      const rate = Number(line.rate) || 0;
      return acc + quantity * rate;
    }, 0);

    // Total discount
    const lineDiscountSum = this.addedServiceLines.reduce((acc, line) => {
      return acc + (Number(line.discountAmount) || 0);
    }, 0);

    if (lineDiscountSum > 0 || this.addedServiceLines.length > 0) {
      this.totalDiscount = lineDiscountSum;
    }

    // Taxable amount = Subtotal - Discount
    this.taxableAmount = Math.max(this.subTotal - this.totalDiscount, 0);

    // GST is calculated on taxable amount, NOT subtotal
    if (this.isGstTransaction) {
      const totalGstPercent =
        (Number(this.igstPercent) || 0) +
        (Number(this.cgstPercent) || 0) +
        (Number(this.sgstPercent) || 0);

      this.gstAmount = (this.taxableAmount * totalGstPercent) / 100;
    } else {
      this.gstAmount = 0;
    }

    // Grand Total = Taxable Amount + GST
    this.grandTotal = this.taxableAmount + this.gstAmount;
  }

  lFN_GetTransactionById(id: number): void {
    this.l_UtilityService.lFN_ShowLoader();
    this.l_TransactionMasterService.lFN_GetTransactionById(id).subscribe({
      next: (res: any) => {
        this.l_UtilityService.lFN_HideLoader();
        const parsed = JSON.parse(res.body);
        console.log(parsed);
        this.populateForm(parsed?.data);
      },
      error: () => {
        this.l_UtilityService.lFN_HideLoader();
        this.l_UtilityService.lFN_ErrorToaster(
          'Failed to load transaction details',
          'Error'
        );
      },
    });
  }

  populateForm(data: any): void {
    if (!data) return;
    this.transactionId = data.transactionId || null;
    this.transactionNo = data.transactionNo || '';
    this.selectedCustomerId =
      data.customerId != null ? Number(data.customerId) : null;
    this.transactionType = data.transactionType;
    this.transactionDate = new Date(data.transactionDate);
    this.isGstTransaction = data.isGstTransaction === 'YES';
    this.igstPercent = data.igstPercent || 0;
    this.cgstPercent = data.cgstPercent || 0;
    this.sgstPercent = data.sgstPercent || 0;
    this.totalDiscount = data.totalDiscount || 0;

    if (data.transactionDetails && data.transactionDetails.length > 0) {
      this.addedServiceLines = data.transactionDetails.map((detail: any) => {
        console.log(detail);
        const service = this.serviceList.find(
          (s) => s.serviceHeaderId == detail.serviceId
        );
        const unit = this.unitList.find((u) => u.unitId == detail.unitId);
        const isCustomSms =
          detail.scheduleCustomSms === true ||
          detail.scheduleCustomSms === 'YES' ||
          detail.scheduleCustomSms === 'Y' ||
          detail.scheduleCustomSms === 1;
        const customSmsDates = isCustomSms
          ? (detail.smsLogs || [])
            .filter((log: any) => log && log.smsScheduledOn)
            .map((log: any) => new Date(log.smsScheduledOn))
          : [];

        const qty = detail.quantity || 0;
        const rate = detail.rate || 0;
        const gross = qty * rate;
        let discountAmount = detail.discountAmount || 0;
        if (!discountAmount && detail.discountPercent && gross > 0) {
          discountAmount = Number(((gross * detail.discountPercent) / 100).toFixed(2));
        }
        const lineAmount = detail.amount || (gross - discountAmount > 0 ? gross - discountAmount : 0);

        return {
          transactionDetailId: detail.transactionDetailId || null,
          serviceHeaderId:
            detail.serviceId != null ? Number(detail.serviceId) : null,
          serviceName: service ? service.serviceName : '',
          unitId: detail.unitId != null ? Number(detail.unitId) : null,
          unit: unit ? unit.unitName : '',
          workUnits: detail.workUnits ? String(detail.workUnits) : null,
          serviceStartDate: detail.serviceStartDate
            ? formatDateForAPI(detail.serviceStartDate)
            : null,
          serviceExpiryDate: detail.serviceExpiryDate
            ? formatDateForAPI(detail.serviceExpiryDate)
            : null,
          serviceExpiryInMonths: detail.serviceExpiryInMonths || 0,
          quantity: qty,
          rate: rate,
          discountPercent: detail.discountPercent || 0,
          discountAmount: discountAmount,
          amount: lineAmount,
          scheduleCustomSms: isCustomSms,
          scheduleCustomSmsList: customSmsDates,
          serviceWorkDescription: detail.serviceWorkDescription || '',
        };
      });
    }
    this.calculateTotals();
  }

  lFN_SaveTransaction(): void {
    if (!this.transactionType) {
      this.l_UtilityService.lFN_ErrorToaster(
        'Please select a Transaction Type',
        'Validation Error'
      );
      return;
    }
    if (!this.selectedCustomerId) {
      this.l_UtilityService.lFN_ErrorToaster(
        'Please select a customer',
        'Validation Error'
      );
      return;
    }
    if (this.addedServiceLines.length === 0) {
      this.l_UtilityService.lFN_ErrorToaster(
        'Please add at least one service',
        'Validation Error'
      );
      return;
    }

    const clientMaster = JSON.parse(
      sessionStorage.getItem('client_master') || '{}'
    );
    const clientId = clientMaster.clientId || 0;

    const transactionDetails = this.addedServiceLines.map((line) => {
      const quantity = line.quantity || 1;
      const rate = line.rate || 0;
      const discountAmount = line.discountAmount || 0;
      const grossAmount = quantity * rate;
      const discountPercent =
        grossAmount > 0
          ? Number(((discountAmount / grossAmount) * 100).toFixed(2))
          : 0;

      return {
        transactionDetailId:
          line.transactionDetailId != null ? line.transactionDetailId : null,
        serviceHeaderId: line.serviceHeaderId,
        unitId: line.unitId,
        workUnits: line.workUnits ? String(line.workUnits) : null,
        scheduleCustomSms:
          line.scheduleCustomSmsList && line.scheduleCustomSmsList.length > 0,
        serviceStartDate: line.serviceStartDate
          ? formatDateForAPI(line.serviceStartDate)
          : null,
        serviceExpiryDate: line.serviceExpiryDate
          ? formatDateForAPI(line.serviceExpiryDate)
          : null,
        serviceExpiryInMonths: line.serviceExpiryInMonths || 0,
        quantity: quantity,
        rate: rate,
        discountPercent: discountPercent,
        discountAmount: discountAmount,
        amount: line.amount || 0,
        scheduleCustomSmsList: (line.scheduleCustomSmsList || []).map(
          (date: any) => formatDateForAPI(date)
        ),
        serviceWorkDescription: line.serviceWorkDescription || '',
      };
    });

    const taxableAmount = Math.max(this.subTotal - this.totalDiscount, 0);
    const totalDiscountPercent =
      this.subTotal > 0
        ? Number(((this.totalDiscount / this.subTotal) * 100).toFixed(2))
        : 0;

    const payload: TransactionCreatePayload = {
      transactionId: this.transactionId != null ? this.transactionId : null,
      transactionNo: this.transactionNo ? this.transactionNo : null,
      transactionType: this.transactionType!,
      parentTransactionId: null,
      clientId: clientId,
      customerId: this.selectedCustomerId,
      isGstTransaction: this.isGstTransaction ? 'YES' : 'NO',
      igstPercent: this.igstPercent || 0,
      igstAmount: this.isGstTransaction
        ? (taxableAmount * (this.igstPercent || 0)) / 100
        : 0,
      cgstPercent: this.cgstPercent || 0,
      cgstAmount: this.isGstTransaction
        ? (taxableAmount * (this.cgstPercent || 0)) / 100
        : 0,
      sgstPercent: this.sgstPercent || 0,
      sgstAmount: this.isGstTransaction
        ? (taxableAmount * (this.sgstPercent || 0)) / 100
        : 0,
      totalDiscountPercent: totalDiscountPercent,
      totalDiscount: this.totalDiscount,
      totalAmount: this.grandTotal,
      transactionStatus: 'P',
      transactionDate: this.transactionDate
        ? new Date(this.transactionDate).toISOString()
        : new Date().toISOString(),
      metadataJson: '{}',
      transactionDetails: transactionDetails,
    };
    console.log(payload);

    this.l_UtilityService.lFN_ShowLoader();
    console.log('Payload ===>', JSON.stringify(payload, null, 2));

    const isUpdate = !!this.transactionId;
    const saveObservable = isUpdate
      ? this.l_TransactionMasterService.lFN_UpdateTransactionById(
        this.transactionId!,
        payload
      )
      : this.l_TransactionMasterService.lFN_SaveTransaction(payload);

    saveObservable.subscribe({
      next: (res: any) => {
        this.l_UtilityService.lFN_SuccessToaster(
          isUpdate
            ? 'Transaction updated successfully'
            : 'Transaction saved successfully',
          'Success'
        );
        this.addedServiceLines = [];
        this.transactionId = null;
        this.transactionNo = '';
        this.selectedCustomerId = null;
        this.transactionType = null;
        this.isGstTransaction = false;
        this.igstPercent = 0;
        this.cgstPercent = 0;
        this.sgstPercent = 0;
        this.lFN_ClearServiceLine();
        this.calculateTotals();
      },
      error: (err: any) => {
        this.l_UtilityService.lFN_ErrorToaster(
          err?.error?.message || 'Failed to save transaction',
          'Error'
        );
      },
      complete: () => {
        this.l_UtilityService.lFN_HideLoader();
      },
    });
  }
}

function formatDateForAPI(date: any) {
  if (!date) return null;

  // if already YYYY-MM-DD
  if (typeof date === 'string' && date.includes('-')) {
    return `${date.split('T')[0]}T00:00:00`;
  }

  // if Date object
  const d = new Date(date);
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');

  return `${yyyy}-${mm}-${dd}T00:00:00`;
}
